import Tab from 'component/molecules/Tab/TabComponent';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React, { useRef, useState } from 'react';
import ThemesTab from './template/themesTab/ThemesTab';
import CustomizedThemeTab from './template/customizedThemesTab/CustomizedThemeTab';
import NewTheme from 'component/organism/theme/new-theme/NewTheme';
import { usePost } from 'hooks/usePost';
import { companyEndpoints, settingsEndpoints } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { themeToast } from 'helpers/toastMessages';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';

const ThemeSettings = () => {
  const { id } = useParams();
  const [mode, setMode] = useState('');
  const [selected, setSelected] = useState('Themes');
  const [activeTab, setActiveTab] = useState(0);
  const ref = useRef(null);
  const { showModal } = useTour();

  const { data, isFetching, refetch } = useFetch(
    ['chatSettingsThemeData', id],
    companyEndpoints.getChatSettings,
    { enabled: true },
    { botId: id }
  );

  const { mutate: submitTheme, isPending } = usePost({
    onSuccessToast: 'Added Successfully',
    toastType: 'add',
  });

  const { mutate: saveChosenTheme, isPending: isSaving } = usePost({
    onSuccessToast: themeToast.save,
    toastType: 'add',
  });

  const tabs = [
    {
      label: 'Themes',
      content: <ThemesTab ref={ref} chatSettingsThemeData={data} />,
    },
    {
      label: 'Customized',
      content: <CustomizedThemeTab ref={ref} chatSettingsThemeData={data} />,
    },
  ];

  const handleTabChange = (index) => {
    setActiveTab(index);
    setSelected(tabs[index].label);
  };

  const handleSave = async () => {
    await ref.current.submitForm();
    const formIsValid = ref.current?.isValid;
    if (!formIsValid) return;

    if (mode === 'newTheme') {
      submitTheme(
        {
          url: settingsEndpoints.postResponseTheme(),
          data: { ...ref?.current?.values },
        },
        {
          onSuccess: () => {
            setMode(null);
            setActiveTab(1);
            setSelected(tabs[1].label);
          },
        }
      );
    } else {
      saveChosenTheme(
        {
          url: companyEndpoints.setCompanyChatSettings(),
          data: { ...ref?.current?.values, botId: id },
        },
        { onSuccess: () => refetch() }
      );
    }
  };

  return (
    <>
      <SettingsHeader
        title='Themes'
        rightButtons={[
          ...(mode !== 'newTheme' && selected !== 'Themes'
            ? [
                {
                  label: 'New Custom Theme',
                  func: () => setMode('newTheme'),
                  opicBackground: true,
                },
              ]
            : []),
          ...(mode === 'newTheme'
            ? [
                {
                  label: 'Reset',
                  opicBackground: true,
                  func: () => ref.current?.resetForm(),
                },
                {
                  label: 'Cancel',
                  opicBackground: true,
                  func: () => setMode(null),
                },
              ]
            : []),
          {
            label: 'Save',
            type: 'save',
            func: handleSave,
            isLoading: isPending || isSaving,
          },
        ]}
      />

      {mode === 'newTheme' ? (
        <NewTheme
          ref={ref}
          setMode={setMode}
          setActiveTab={setActiveTab}
          submitTheme={submitTheme}
        />
      ) : (
        <Tab tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />
      )}

      {showModal && <TourModal />}
    </>
  );
};

export default ThemeSettings;
